
module dg.navigation {

    export interface ILinkAttributes extends ng.IAttributes {
        linkType: string;
    }

    export class NavActionController {

        public constructor(
            public navigationService: NavigationService
        ) {

        }

        public text: string;

        public onExecute: Function;
        public isExecuting: boolean;
        public link: dg.restfulApi.Link;
        public linkText: string;
        public hoverText: string;
        public cssClasses: string;
        public isDisabled: boolean;
        public isInvocationLink: boolean;

        public linkClick = ($event) => {
            //$event.stopPropagation();
            $event.preventDefault();

            //raise event click -> link, action = selected, item
            if (this.onExecute) {
                this.onExecute();
            }

            if (this.link) {
                this.navigationService.navigate(this.link);
            }
        }

        public getLinkText = () => {
            return angular.isDefined(this.linkText) ? this.linkText : this.link ? this.link.title : '';
        }

        $onInit = () => {
            this.isInvocationLink = !!this.link;
            //this.text = this.getLinkText();
        }

        $onChanges = (changes) => {
            this.text = this.getLinkText();
        }
    }

    angular.module('dg.navigation').component('navAction', {
        bindings: {
            link: '<',
            linkText: '@',
            hoverText: '@',
            iconClass: '@',
            cssClasses: '@',
            onExecute: '&?',
            isDisabled: '<',
            isExecuting: '<'
        },
        controller: NavActionController,
        templateUrl: ($element, $attrs: ILinkAttributes) => {

            let templateName = 'button';
            if ($attrs.linkType == 'a') {
                templateName = 'link';
            }
            else if ($attrs.linkType == 'grid') {
                templateName = 'grid';
            }
            else if ($attrs.linkType == 'icon') {
                templateName = 'icon';
            }
            return '/digmo/src/navigation/nav-' + templateName + '.html'
        },
    });
}
